module.exports = __webpack_public_path__ + "img/twintLogo.ec034295.svg";